'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Search, _div, _div2, _Loader;
var _excluded = ["className", "debounceDelay", "onSearch"],
  _excluded2 = ["className", "children", "loading"],
  _excluded3 = ["children", "className"],
  _excluded4 = ["className", "open", "placeholder", "size", "value"];
import * as React from 'react';
import debounce from 'lodash.debounce';
import ArrowIosDown from '@crehana/compass.icons.outline/ArrowIosDown';
import ArrowIosUp from '@crehana/compass.icons.outline/ArrowIosUp';
import Search from '@crehana/compass.icons.outline/Search';
import { useTranslation } from '@crehana/i18n';
import Loader from "../../../Loader/Loader";
import { Command, CommandEmpty, CommandInput, CommandList, CommandLoadingPrimitive } from "../../_shadcn-native-components/command";
import { Popper, PopperContent, PopperTrigger } from "../../Popper";
import { cn } from "../../utils";
import locales from "../i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PrimitiveDropdown = Popper;
export var PrimitiveDropdownClientSearch = CommandInput;
export var PrimitiveDropdownApiSearch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$debounceDelay = _ref.debounceDelay,
    debounceDelay = _ref$debounceDelay === void 0 ? 300 : _ref$debounceDelay,
    onSearch = _ref.onSearch,
    props = _objectWithoutProperties(_ref, _excluded);
  var debouncedOnFilter = React.useCallback(debounce(function (value) {
    return onSearch(value);
  }, debounceDelay), [debounceDelay]);
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-items-center tw-border-solid tw-border-b tw-border-neutral-light-400 dark:tw-border-neutral-dark-500",
    children: [_Search || (_Search = /*#__PURE__*/_jsx(Search, {
      size: 24,
      className: "tw-ml-2.4 tw-mr-1.2 tw-shrink-0 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500"
    })), /*#__PURE__*/_jsx("input", _objectSpread({
      ref: ref,
      className: cn('tw-flex tw-w-full tw-pr-2.4 tw-py-1.2 tw-outline-none tw-font-body4', 'placeholder:tw-text-neutral-light-700 disabled:tw-cursor-not-allowed tw-text-neutral-light-800', 'dark:placeholder:tw-text-neutral-dark-500 dark:tw-text-neutral-light-100', 'tw-bg-transparent', className),
      onChange: function onChange(e) {
        return debouncedOnFilter(e.target.value);
      }
    }, props))]
  });
});
export var PrimitiveDropdownEmpty = function PrimitiveDropdownEmpty(_ref2) {
  var title = _ref2.title,
    subtitle = _ref2.subtitle;
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  return /*#__PURE__*/_jsxs(CommandEmpty, {
    className: "tw-flex tw-flex-col tw-items-center tw-justify-center",
    children: [_div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-rounded-full dark:tw-bg-neutral-dark-600 tw-bg-neutral-light-300 tw-flex tw-items-center tw-justify-center tw-h-[60px] tw-w-[60px] tw-mb-0.8",
      children: /*#__PURE__*/_jsx(Search, {
        size: 24,
        className: "tw-text-neutral-light-600 dark:tw-text-neutral-dark-400"
      })
    })), /*#__PURE__*/_jsx("div", {
      className: "tw-font-link1 dark:tw-text-neutral-light-100",
      children: title !== null && title !== void 0 ? title : locales[languageCode].DROPDOWN_EMPTY_TITLE
    }), subtitle && /*#__PURE__*/_jsx("p", {
      className: "tw-mt-0.4 tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400",
      children: subtitle
    })]
  });
};
export var PrimitiveDropdownApiEmpty = function PrimitiveDropdownApiEmpty(_ref3) {
  var title = _ref3.title,
    subtitle = _ref3.subtitle;
  var _useTranslation2 = useTranslation(),
    languageCode = _useTranslation2.languageCode;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-py-5.6 tw-px-2.4 tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center",
    children: [_div2 || (_div2 = /*#__PURE__*/_jsx("div", {
      className: "tw-rounded-full dark:tw-bg-neutral-dark-600 tw-bg-neutral-light-300 tw-flex tw-items-center tw-justify-center tw-h-[60px] tw-w-[60px] tw-mb-0.8",
      children: /*#__PURE__*/_jsx(Search, {
        size: 24,
        className: "tw-text-neutral-light-600 dark:tw-text-neutral-dark-400"
      })
    })), /*#__PURE__*/_jsx("div", {
      className: "tw-font-link1 dark:tw-text-neutral-light-100",
      children: title !== null && title !== void 0 ? title : locales[languageCode].DROPDOWN_EMPTY_TITLE
    }), subtitle && /*#__PURE__*/_jsx("p", {
      className: "tw-mt-0.4 tw-font-body5 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400",
      children: subtitle
    })]
  });
};
export var PrimitiveDropdownTrigger = PopperTrigger;
export var PrimitiveDropdownList = CommandList;
export var PrimitiveDropdownLoading = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    children = _ref4.children,
    loading = _ref4.loading,
    props = _objectWithoutProperties(_ref4, _excluded2);
  var _useTranslation3 = useTranslation(),
    languageCode = _useTranslation3.languageCode;
  if (!loading) {
    return null;
  }
  return /*#__PURE__*/_jsx(CommandLoadingPrimitive, _objectSpread(_objectSpread({
    ref: ref,
    className: cn('tw-flex tw-justify-center tw-items-center tw-h-24', className)
  }, props), {}, {
    children: children || /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-space-y-1.2 tw-font-body5 tw-text-neutral-light-700",
      children: [_Loader || (_Loader = /*#__PURE__*/_jsx(Loader, {})), /*#__PURE__*/_jsx("p", {
        children: locales[languageCode].DROPDOWN_LOADING
      })]
    })
  }));
});
export var PrimitiveDropdownContent = function PrimitiveDropdownContent(_ref5) {
  var children = _ref5.children,
    className = _ref5.className,
    popperProps = _objectWithoutProperties(_ref5, _excluded3);
  return /*#__PURE__*/_jsx(PopperContent, _objectSpread(_objectSpread({
    removePadding: true,
    sideOffset: 14,
    align: "start",
    className: cn('tw-rounded tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700 dark:tw-shadow-none tw-m-0 tw-overflow-hidden tw-min-w-20', className)
  }, popperProps), {}, {
    children: /*#__PURE__*/_jsx(Command, {
      className: "tw-rounded",
      children: children
    })
  }));
};
export var PrimitiveDropdownValueButton = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
    open = _ref6.open,
    placeholder = _ref6.placeholder,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? 'small' : _ref6$size,
    value = _ref6.value,
    buttonProps = _objectWithoutProperties(_ref6, _excluded4);
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    ref: ref,
    type: "button",
    className: cn('tw-input tw-group disabled:tw-text-neutral-light-500 disabled:dark:tw-text-neutral-dark-600', !value ? 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500' : 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100', size === 'small' ? 'tw-h-4 tw-font-body4' : 'tw-h-5.6 tw-font-body3', className),
    role: "combobox",
    "aria-expanded": open
  }, buttonProps), {}, {
    children: [/*#__PURE__*/_jsx("span", {
      className: cn('tw-grow tw-text-left tw-max-w-full tw-overflow-hidden tw-text-ellipsis tw-line-clamp-1'),
      children: value || placeholder
    }), open ? /*#__PURE__*/_jsx(ArrowIosUp, {
      size: 24,
      className: cn('group-disabled:tw-text-neutral-light-500 group-disabled:dark:tw-text-neutral-dark-600 tw-text-primary-light-500 tw-shrink-0 dark:tw-text-secondary-dark-500', 'group-data-[state=closed]:tw-hidden')
    }) : /*#__PURE__*/_jsx(ArrowIosDown, {
      size: 24,
      className: cn('group-disabled:tw-text-neutral-light-500 group-disabled:dark:tw-text-neutral-dark-600 tw-text-primary-light-500 tw-shrink-0 dark:tw-text-secondary-dark-500', 'group-data-[state=open]:tw-hidden')
    })]
  }));
});